import { render, staticRenderFns } from "./upfitter.vue?vue&type=template&id=8add8fb0&scoped=true"
import script from "./upfitter.vue?vue&type=script&lang=js"
export * from "./upfitter.vue?vue&type=script&lang=js"
import style0 from "./upfitter.vue?vue&type=style&index=0&id=8add8fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8add8fb0",
  null
  
)

export default component.exports